module.exports = __webpack_public_path__ + "media/images/landing/illust/bg-hero-v2-mobile-fdbac43a5b232136309eeca5ae3bfb9c.svg";